import { all, take, call, put, select, actionChannel } from 'redux-saga/effects';
import { getUploads, getUploadsWaiting, getAttachmentUploads, getAttachmentUploadsWaiting } from '../selectors';
const MAXIMUM_CONCURRENT_UPLOADS = 10;
function* uploadQueueHandler(uploadType, uploadAction, sequenceUploads) {
    const uploads = yield select(uploadType === 'attachment' ? getAttachmentUploads : getUploads);
    const activeUploads = uploads.filter((upload)=>!upload.error);
    const openUploadSlots = sequenceUploads ? 1 - activeUploads.length : MAXIMUM_CONCURRENT_UPLOADS - activeUploads.length;
    if (openUploadSlots <= 0) {
        // do nothing, we have no space to queue more
        return;
    }
    const waitingUploads = yield select(uploadType === 'attachment' ? getAttachmentUploadsWaiting : getUploadsWaiting);
    // start downloading the appropriate amount
    yield all(waitingUploads.slice(0, openUploadSlots).map((upload)=>put(uploadAction(upload))));
}
export function* uploadQueueWatcher(uploadType, watchActions, uploadAction, sequenceUploads = false) {
    const channel = yield actionChannel(watchActions);
    while(true){
        yield take(channel);
        yield call(uploadQueueHandler, uploadType, uploadAction, sequenceUploads);
    }
}

//# sourceMappingURL=queue.js.map